import React from "react";
import Base from "./components/Base";
export function App() {
    return <Base />;
}